import React from "react";
import { convertToHTML } from "draft-convert";

const ExportTable = function (props) {
  const data = props.data;
  const table = data.table || [];
  if (!table || !Array.isArray(table)) return <>{props.children}</>;
  const classes = props.appendClasses || [];
  return (
    <table>
      <tbody>
        {table.map((row, index) => {
          return (
            <tr>
              {row.map((col) => {
                return (
                  <td
                    className={`       
                            ${
                              data.align &&
                              col.self &&
                              `editor-block-align-${data.align}`
                            }                  
                            ${
                              col.borderLeft
                                ? "editor-table-cell-border-left"
                                : ""
                            }
                            ${
                              col.borderRight
                                ? "editor-table-cell-border-right"
                                : ""
                            } 
                            ${
                              col.borderTop
                                ? "editor-table-cell-border-top"
                                : ""
                            }
                            ${
                              col.borderBottom
                                ? "editor-table-cell-border-bottom"
                                : ""
                            }
                            ${
                              col.padding
                                ? `editor-table-cell-padding-${col.padding}`
                                : ""
                            }
                             
                        `}
                    id={`portal-gate-${col.key}`}
                    style={{
                      backgroundColor: col.backgroundColor,
                      width: col.width && `${col.width}%`,
                      verticalAlign: col.verticalAlign,
                    }}
                  >
                    {col.self && (
                      <div
                        className={classes.join(" ")}
                        data-blockid={data.key}
                      >
                        {props.children}
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const ExportTableCell = function (props) {
  const data = props.data;
  const classes = props.appendClasses || [];
  return (
    <div className="portal-source" data-to={data.key}>
      <div
        className={` 
        ${classes.join(" ")}                        
        ${data.align && `editor-block-align-${data.align}`}         
    `}
      >
        <div data-blockid={data.key}>{props.children}</div>
      </div>
    </div>
  );
};

const ExportHeader = function (props) {
  let children = <>{props.children}</>;
  switch (props.blockType) {
    case "header-one":
      children = <h1 data-blockid={props.block.key}>{children}</h1>;
      break;
    case "header-two":
      children = <h2 data-blockid={props.block.key}>{children}</h2>;
      break;
    case "header-three":
      children = <h3 data-blockid={props.block.key}>{children}</h3>;
      break;
    case "header-four":
      children = <h4 data-blockid={props.block.key}>{children}</h4>;
      break;
    case "header-five":
      children = <h5 data-blockid={props.block.key}>{children}</h5>;
      break;
    case "header-six":
      children = <h6 data-blockid={props.block.key}>{children}</h6>;
      break;
    default:
      break;
  }

  return (
    <div className={props.className}>
      <a name={props.block.key}></a>
      {children}
    </div>
  );
};

// {blockDataKey}-{value}
const blockClassesMap = {
  "align-left": "text-left",
  "align-right": "text-right",
  "align-center": "text-center",
};

const ORDERED_LIST_TYPES = ["1", "a", "i"];

export const styleToHTML = (style) => {
  if (style.startsWith("fontSize")) {
    const size = style.slice(8);
    if (size) {
      return <span style={{ fontSize: `${size}px` }} />;
    }
  }
  if (style.startsWith("fontColor")) {
    const color = style.slice(9);
    if (color) {
      return <span style={{ color: `${color}` }} />;
    }
  }
  switch (style) {
    case "ITALIC":
      return <em className="italic" />;
    case "BOLD":
      return <strong className="bold" />;
    case "fontTimes":
      return <span style={{ fontFamily: "Times New Roman" }} />;
    case "fontArial":
      return <span style={{ fontFamily: "Arial" }} />;
    case "fontCourier":
      return <span style={{ fontFamily: "Courier New" }} />;
    case "fontComic":
      return <span style={{ fontFamily: "Comic Sans MS" }} />;
    default:
      return null;
  }
};

export const blockToHTML = (block) => {
  const blockType = block.type;
  const blockData = block.data;

  let appendClasses = [];

  if (!block.text) {
    appendClasses.push("empty");
  }

  for (let blockDataKey in blockData) {
    appendClasses.push(`block-${blockDataKey}-${blockData[blockDataKey]}`);
    let classValue =
      blockClassesMap[`${blockDataKey}-${blockData[blockDataKey]}`];
    if (classValue) {
      appendClasses.push(classValue);
    }
  }

  const sClasses = appendClasses.join(" ");

  if (blockType.startsWith("header")) {
    return (
      <ExportHeader
        className={`${sClasses}`}
        block={block}
        blockType={blockType}
      />
    );
  }

  switch (blockType) {
    case "paragraph":
      return (
        <p
          data-blockid={block.key}
          data-block={JSON.stringify(blockData)}
          className={` ${sClasses}`}
        />
      );
    case "unstyled":
      return (
        <p
          data-blockid={block.key}
          data-block={JSON.stringify(blockData)}
          className={`unstyled ${sClasses}`}
        />
      );
    case "nopadding":
      return (
        <p
          data-blockid={block.key}
          data-block={JSON.stringify(blockData)}
          className={`nopadding ${sClasses}`}
        />
      );
    case "unordered-list-item":
      return {
        element: (
          <li
            data-blockid={block.key}
            data-block={JSON.stringify(blockData)}
            className={` ${sClasses}`}
          />
        ),
        nest: <ul />,
      };
    case "ordered-list-item":
      return {
        element: (
          <li
            data-blockid={block.key}
            data-block={JSON.stringify(blockData)}
            className={` ${sClasses}`}
          />
        ),
        nest: (depth) => {
          const type = ORDERED_LIST_TYPES[depth % 3];
          return <ol type={type} />;
        },
      };
    case "grid": {
      let classes = appendClasses;
      classes.push("grid-cell");
      if (blockData.borderLeft) classes.push("grid-cell-border-left");
      if (blockData.borderRight) classes.push("grid-cell-border-right");
      if (blockData.borderTop) classes.push("grid-cell-border-top");
      if (blockData.borderBottom) classes.push("grid-cell-border-bottom");
      return (
        <div
          data-blockid={block.key}
          data-block={JSON.stringify(blockData)}
          style={{
            width: blockData.width || blockData.minWidth,
            height: blockData.height || blockData.minHeight,
          }}
          className={classes.join(" ")}
        />
      );
    }
    case "table": {
      return <ExportTable appendClasses={appendClasses} data={blockData} />;
    }
    case "cell": {
      return <ExportTableCell appendClasses={appendClasses} data={blockData} />;
    }

    default:
      return null;
  }
};

export const entityToHTML = (entity, text) => {
  const data = entity.data;
  if (entity.type === "USER_LINK") {
    let href = "";
    if (data.linkType === "url") {
      href = data.linkURL;
    }
    if (data.linkType === "internal_document") {
      href = `/manual/all/${data.linkDocument}/`;
    }
    if (data.linkType === "header") {
      href = `#${data.linkAnchor}`;
    }

    return (
      <a
        className="link"
        target={data.linkType === "url" && "blank"}
        href={href}
      >
        {text}
      </a>
    );
  }
  if (entity.type === "USER_INPUT") {
    text = " ";
    if (data.kind === "text") {
      if (data.multiline) {
        return (
          <span className="user-input-entity">
            <textarea
              type="text"
              data-name={data.name}
              data-code={data.code}
              name={data.code}
              id={data.code}
              style={{
                width: data.width || data.minWidth,
                height: data.height || data.minHeight,
              }}
            >
              {text}
            </textarea>
          </span>
        );
      } else {
        return (
          <span className="user-input-entity">
            <input
              type="text"
              data-name={data.name}
              data-code={data.code}
              name={data.code}
              id={data.code}
              style={{
                width: data.width || data.minWidth,
                height: data.height || data.minHeight,
              }}
            />
            {text}
          </span>
        );
      }
    }
    if (data.kind === "select") {
      let list = data.list || [];
      return (
        <span className="user-input-entity">
          <select
            type="text"
            data-name={data.name}
            data-code={data.code}
            name={data.code}
            id={data.code}
            style={{
              width: data.width || data.minWidth,
              height: data.height || data.minHeight,
            }}
          >
            {list.map((item, index) => {
              const listItem = item || {};
              return (
                <option
                  selected={listItem.default ? "selected" : ""}
                  key={index}
                  value={listItem.name}
                >
                  {listItem.name}
                </option>
              );
            })}
          </select>
          {text}
        </span>
      );
    }
    if (data.kind === "check") {
      let list = data.list || [];
      if (data.multiple) {
        return (
          <span className="user-input-entity">
            <span
              className="checkboxes"
              style={{
                display: "inline-block",
                verticalAlign: "middle",

                width: data.width || data.minWidth,
                height: data.height || data.minHeight,
              }}
            >
              {list.map((item, index) => {
                const listItem = item || {};
                return (
                  <span>
                    <input
                      checked={listItem.default ? "selected" : ""}
                      type="checkbox"
                      data-name={data.name}
                      data-code={data.code}
                      data-value={listItem.name}
                      id={`${data.name}${data.code}${listItem.name}${index}`}
                    />
                    <label
                      for={`${data.name}${data.code}${listItem.name}${index}`}
                    >
                      {listItem.name}
                    </label>
                  </span>
                );
              })}
            </span>
            {text}
          </span>
        );
      } else {
        return (
          <span className="user-input-entity">
            <span
              className="checkboxes"
              style={{
                display: "inline-block",
                verticalAlign: "middle",

                width: data.width || data.minWidth,
                height: data.height || data.minHeight,
              }}
            >
              {list.map((item, index) => {
                const listItem = item || {};
                return (
                  <span>
                    <input
                      checked={listItem.default ? "selected" : ""}
                      type="radio"
                      name={`${data.name}${data.code}`}
                      data-name={data.name}
                      data-code={data.code}
                      data-value={listItem.name}
                      id={`${data.name}${data.code}${listItem.name}${index}`}
                    />
                    <label
                      for={`${data.name}${data.code}${listItem.name}${index}`}
                    >
                      {listItem.name}
                    </label>
                  </span>
                );
              })}
            </span>
            {text}
          </span>
        );
      }
    }
  }
  if (entity.type === "USER_IMAGE") {
    return (
      <span className={`user-image float-${data.float}`}>
        <img
          style={{ width: data.width, height: data.height, float: data.float }}
          src={data.image}
          alt=""
        />
        {text}
      </span>
    );
  }
  return text;
};

export const options = {
  styleToHTML,
  blockToHTML,
  entityToHTML,
};

const converterFunction = convertToHTML(options);
export default (contentState) => converterFunction(contentState);
